<template>
  <div class="user_own_discount_list">
    <vs-table
      id="user_own_discount_list"
      stripe
      maxHeight="500px"
      :sst="true"
      :data="userDiscountAndTax"
      @search="updateSearchQuery"
      search
      pagination
      :max-items="this.limit"
      :total="FilteredCountUserDiscount"
      @change-page="handleChangePage"
    >
      <template slot="header">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ page * limit - (limit - (FilteredCountUserDiscount && 1)) }}
                  -
                  {{ FilteredCountUserDiscount - page * limit > 0 ? page * limit : FilteredCountUserDiscount }}
                  of {{ FilteredCountUserDiscount }} (filtered from {{ totalUserDiscount }} total entries)
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="handleChangeLength(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </template>
      <template slot="thead">
        <vs-th>Sr#</vs-th>
        <vs-th>Discount Name</vs-th>
        <vs-th>Discount Percentage</vs-th>
        <vs-th>City Tax</vs-th>
        <vs-th>State Tax</vs-th>
        <vs-th>County Tax</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }" ref="tableBody">
        <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ i + 1 }}
          </vs-td>
          <vs-td>
            {{ tr.name }}
          </vs-td>
          <vs-td>
            <vs-input
              v-if="tr.editMode"
              placeholder="Enter Discount Percentage"
              type="number"
              step="0.01"
              icon-pack="feather"
              icon-after="true"
              class="w-full"
              name="DiscountPercentage"
              :value="tr.value"
              @input="(item) => setUserDiscountState({ action: `userDiscountAndTax[${i}].value`, data: item })"
              max-number="100"
            />
            <span v-else>
              {{ tr.value }}
            </span>
          </vs-td>
          <vs-td>
            <vs-checkbox v-if="tr.editMode" color="primary" :value="tr.city_tax" @input="(item) => setUserDiscountState({ action: `userDiscountAndTax[${i}].city_tax`, data: item })"></vs-checkbox>
            <span v-else>
              {{ tr.city_tax | taxLabelFilter }}
            </span>
          </vs-td>
          <vs-td>
            <vs-checkbox v-if="tr.editMode" color="primary" :value="tr.state_tax" @input="(item) => setUserDiscountState({ action: `userDiscountAndTax[${i}].state_tax`, data: item })"></vs-checkbox>
            <span v-else>
              {{ tr.state_tax | taxLabelFilter }}
            </span>
          </vs-td>
          <vs-td>
            <vs-checkbox v-if="tr.editMode" color="primary" :value="tr.county_tax" @input="(item) => setUserDiscountState({ action: `userDiscountAndTax[${i}].county_tax`, data: item })"></vs-checkbox>
            <span v-else>
              {{ tr.county_tax | taxLabelFilter }}
            </span>
          </vs-td>
          <vs-td>
            <div class="inline-flex" v-if="!tr.editMode">
              <vx-tooltip text="Edit Discount and Tax">
                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="setUserDiscountState({ action: `userDiscountAndTax[${i}].editMode`, data: true })" />
              </vx-tooltip>
              <vx-tooltip text="Delete Discount and Tax">
                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="confirmDeleteDiscountAndTax(tr.id)" />
              </vx-tooltip>
            </div>

            <div class="inline-flex" v-if="tr.editMode === true">
              <vx-tooltip text="Edit Discount and Tax">
                <feather-icon icon="SaveIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="saveEditableData(i)" />
              </vx-tooltip>
              <vx-tooltip text="Delete Discount and Tax">
                <feather-icon
                  icon="XCircleIcon"
                  svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
                  @click="setUserDiscountState({ action: `userDiscountAndTax[${i}].editMode`, data: false })"
                />
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'OwnDiscountTable',
  data: () => ({
    search: null,
    limit: 10,
    page: 1,
    order: []
  }),

  mounted() {
    this.findSystemDiscountAndTax()
  },

  // computed
  computed: {
    ...mapState('setting', ['userDiscountAndTax', 'FilteredCountUserDiscount', 'totalUserDiscount'])
  },

  //methods
  methods: {
    ...mapActions('setting', { removeDiscountAndTax: 'deleteDiscountAndTax', updateDiscountAndTax: 'updateDiscountAndTax', getSystemDiscountAndTax: 'getSystemDiscountAndTax' }),
    ...mapMutations('setting', { setUserDiscountState: 'SET_STATE' }),

    // fetch discount and tax
    async findSystemDiscountAndTax() {
      const payload = { page: this.page, limit: this.limit, search: this.search, order: this.order, type: ['user'] }
      await this.getSystemDiscountAndTax(payload)
    },

    // handle change page
    handleChangePage(page) {
      this.page = page
      this.findSystemDiscountAndTax()
    },

    // edit discount and tax
    editDiscountAndTax(id) {
      this.setState({ action: `userDiscountAndTax[${id}].editMode`, data: true })
    },

    // search record
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.findSystemDiscountAndTax()
    },

    // handle change limit - records per page
    handleChangeLength(limit) {
      this.page = 1
      this.limit = limit
      this.findSystemDiscountAndTax()
    },

    // delete discount and tax
    confirmDeleteDiscountAndTax(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteDiscountAndTax(id),
        acceptText: 'Delete'
      })
    },

    // delete hold invoice
    async deleteDiscountAndTax(id) {
      try {
        const { message } = await this.removeDiscountAndTax(id)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.findSystemDiscountAndTax()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // update editable data
    async saveEditableData(index) {
      this.loading = true
      try {
        const discountData = this.userDiscountAndTax[index]
        const { message } = await this.updateDiscountAndTax({ id: discountData.id, data: discountData })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.findSystemDiscountAndTax()
        this.loading = false
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  filters: {
    taxLabelFilter(val) {
      return val ? 'Exempt' : 'Non-Exempt'
    }
  },

  // watch
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#user_own_discount_list ',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#user_own_discount_list > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
.con-vs-dropdown--menu {
  z-index: 55000;
}

.con-vs-dialog {
  z-index: 530000;
}
</style>